import { DisplayProperties } from '@com-delta-idp/mnx-skymiles-shared';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import { EntryItem, TooltipMetaData } from '@com-delta-omnichannel/aura';

export interface EarnsSummaryAriaLabels {
  action: string;
}

export interface SummaryFooter {
  label: string;
  tooltip: TooltipMetaData;
}

export interface EarnsSummary extends DisplayProperties {
  title: string;
  toggle: EntryItem;
  activities: EntryItem[];
  action: Link;
  summary: SummaryFooter;
  ariaLabels: EarnsSummaryAriaLabels;
}

export interface EarnsSummaryAnalytics {
  action: Link;
  eventType: string;
}
